export default __webpack_public_path__ + "static/media/sweet-memory.ac4e1b3e.jpg";